/* assets/side-menu.js */
document.addEventListener('DOMContentLoaded', function(){
  var wrapper = document.getElementById('side-menu-wrapper');
  var overlay = document.getElementById('side-menu-overlay');
  var closeBtn = document.getElementById('side-menu-close');
  var hamburger = document.querySelector('.hamburger-menu') || document.querySelector('.menu-toggle') || null;

  function openMenu(){
    if(!wrapper) return;
    wrapper.classList.add('open');
    wrapper.setAttribute('aria-hidden','false');
    document.body.classList.add('menu-open');
    document.documentElement.classList.add('menu-open');
  }
  function closeMenu(){
    if(!wrapper) return;
    wrapper.classList.remove('open');
    wrapper.setAttribute('aria-hidden','true');
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
    // close submenus
    wrapper.querySelectorAll('.side-item.sub-open').forEach(i=>i.classList.remove('sub-open'));
    wrapper.querySelectorAll('.side-subitem.sub2-open').forEach(i=>i.classList.remove('sub2-open'));
    wrapper.querySelectorAll('.side-submenu, .side-submenu-2').forEach(el=>el.style.display='none');
  }

  if(hamburger) hamburger.addEventListener('click', openMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  if(overlay) overlay.addEventListener('click', closeMenu);

  if(!wrapper) return;

  // Level 1 toggle
  wrapper.querySelectorAll('.side-link[data-has-submenu="true"]').forEach(function(row){
    row.addEventListener('click', function(e){
      e.preventDefault();
      var item = row.closest('.side-item');
      var submenu = item.querySelector('.side-submenu');
      if(!submenu) return;
      var isOpen = submenu.style.display === 'block';
      wrapper.querySelectorAll('.side-submenu').forEach(function(s){ if(s!==submenu){ s.style.display='none'; if(s.closest('.side-item')) s.closest('.side-item').classList.remove('sub-open'); }});
      if(!isOpen){ submenu.style.display='block'; item.classList.add('sub-open'); } else { submenu.style.display='none'; item.classList.remove('sub-open'); }
    });
  });

  // Level 2 toggle
  wrapper.querySelectorAll('.side-sublink[data-has-subsubmenu="true"]').forEach(function(row){
    row.addEventListener('click', function(e){
      e.preventDefault();
      var li = row.closest('.side-subitem');
      var sub2 = li.querySelector('.side-submenu-2');
      if(!sub2) return;
      var isOpen = sub2.style.display === 'block';
      if(!isOpen){ sub2.style.display='block'; li.classList.add('sub2-open'); } else { sub2.style.display='none'; li.classList.remove('sub2-open'); }
    });
  });

  // ESC to close
  document.addEventListener('keyup', function(e){ if(e.key === 'Escape' && wrapper.classList.contains('open')) closeMenu(); });
});
